export const COMMUNITY_TAG_ACTION_START =
  'COMMUNITY_TAG_ACTION_START';
export const COMMUNITY_TAG_ACTION_ERROR =
  'COMMUNITY_TAG_ACTION_ERROR';
export const GET_ALL_COMMUNITY_TAGS = 'GET_ALL_COMMUNITY_TAGS';
export const CREATE_COMMUNITY_TAG = 'CREATE_COMMUNITY_TAG';
export const DELETE_COMMUNITY_TAG = 'DELETE_COMMUNITY_TAG';

export const communityTagActionStart = () => ({
  type: COMMUNITY_TAG_ACTION_START,
});

export const communityTagActionError = (error: any) => ({
  type: COMMUNITY_TAG_ACTION_ERROR,
  payload: error,
});

export const getAllCommunityTagsAction = (tags: any[]) => ({
  type: GET_ALL_COMMUNITY_TAGS,
  payload: tags,
});

export const createCommunityTagAction = (tag: any) => ({
  type: CREATE_COMMUNITY_TAG,
  payload: tag,
});

export const deleteCommunityTagAction = (id: string) => ({
  type: DELETE_COMMUNITY_TAG,
  payload: id,
});

